import { GET_INVENTORY_ITEMS_LIST } from "@actions/inventory/stock/itemsList/types";

import {
  ItemsListState,
  ItemsListStateAction,
} from "@reducers/types/inventory/stock/items-list-state";

export const initialState: ItemsListState = {
  isGetLoading: false,
  isGetSingleLoading: false,
  isUpdateLoading: false,
  isDeleteLoading: false,
  isCreateLoading: false,

  getError: null,
  getSingleError: null,
  createError: null,
  updateError: null,
  deleteError: null,

  getSuccess: false,
  getSingleSuccess: false,
  createSuccess: false,
  updateSuccess: false,
  deleteSuccess: false,

  getData: null,
  getSingleData: null,
};

const itemsListReducer = (
  state: ItemsListState = initialState,
  action: ItemsListStateAction,
): ItemsListState => {
  const { type, payload } = action;

  switch (type) {
    // fetch
    case GET_INVENTORY_ITEMS_LIST.LOADING:
      return {
        ...state,
        isGetLoading: payload,
        getSuccess: false,
        getData: null,
        getError: null,
      };

    case GET_INVENTORY_ITEMS_LIST.ERROR:
      return {
        ...state,
        getError: payload,
        getData: null,
        isGetLoading: false,
      };

    case GET_INVENTORY_ITEMS_LIST.SUCCESS:
      //   const modifiedData = payload?.data?.map((item: any) => {
      //     return {
      //       ...item,
      //       group: item?.product?.name?. || {},
      //       category: item?.product?.group?.category || {},
      //     };
      //   });

      return {
        ...state,
        getError: null,
        getData: payload,
        getSuccess: true,
        isGetLoading: false,
      };

    default:
      return state;
  }
};

export default itemsListReducer;
